//
// Main Navigation
// Snap navbar dropdown menu to the right (calculate margin-right on window resize)
//
$(window).resize(function(){
    setTimeout(function() {
        $('.dropdown-menu-snap-right').each(function(index, item) {
            if ($(window).width() >= 992) {
                var navbarItem = $(item).prev();
                var navbar = $(navbarItem).closest('.navbar-nav');

                var navbarItemOffsetRight = ($(window).width() - ($(navbarItem).offset().left + $(navbarItem).outerWidth()));
                var navbarOffsetRight = ($(window).width() - ($(navbar).offset().left + $(navbar).outerWidth()));

                var calculatedMarginRight = (navbarOffsetRight - navbarItemOffsetRight);
                $(item).css('margin-right', calculatedMarginRight);
            } else {
                $(item).css('margin-right', 0);
            }
        })
    }, 300);
}).resize();